import { useState, type FormEvent } from "react";
import { Modal } from "../../components/Modal.tsx";
import { api } from "../../api.ts";

export function RecoveryCodes() {
  const [open, setOpen] = useState(false);
  const [codes, setCodes] = useState<string[]>([]);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  function changeOpen(value: boolean) {
    if (busy) return;
    setOpen(value);
    if (!value) {
      setCodes([]);
      setMessage("");
    }
  }
  async function generate(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const fields = new FormData(form);
    const password = String(fields.get("password") ?? "");
    setBusy(true);
    setMessage("");
    try {
      await api("/api/security/reauthenticate", {
        password,
        code: fields.get("code"),
      });
      const result = await api<{ data: { backupCodes: string[] } }>(
        "/api/security/recovery-codes",
        { password },
      );
      form.reset();
      setCodes(result.data.backupCodes);
    } catch (error) {
      setMessage(
        error instanceof Error
          ? error.message
          : "Não foi possível gerar os códigos.",
      );
    } finally {
      setBusy(false);
    }
  }
  return (
    <>
      <button className="button secondary" onClick={() => changeOpen(true)}>
        Renovar códigos de recuperação
      </button>
      <Modal
        open={open}
        onOpenChange={changeOpen}
        title="Códigos de recuperação"
        description="Guarde os códigos em um local seguro fora deste computador. Cada código funciona uma única vez."
      >
        {codes.length ? (
          <div className="form">
            <p role="status">
              Novos códigos gerados. Os códigos anteriores deixaram de
              funcionar.
            </p>
            <pre className="recovery-codes">{codes.join("\n")}</pre>
            <p className="muted">
              Eles desaparecem desta tela ao fechar. Para gerar outra lista,
              será preciso confirmar sua identidade novamente.
            </p>
            <button
              className="button primary"
              onClick={() => changeOpen(false)}
            >
              Guardei os códigos
            </button>
          </div>
        ) : (
          <form className="form" onSubmit={generate}>
            <label>
              Senha atual
              <input
                name="password"
                type="password"
                autoComplete="current-password"
                required
                maxLength={128}
              />
            </label>
            <label>
              Código atual do autenticador
              <input
                name="code"
                inputMode="numeric"
                autoComplete="one-time-code"
                pattern="[0-9]{6}"
                maxLength={6}
                required
              />
            </label>
            <label className="recovery-acknowledgement">
              <input type="checkbox" required />
              Entendo que os códigos anteriores serão invalidados
            </label>
            {message && (
              <p role="alert" className="form-error">
                {message}
              </p>
            )}
            <button className="button primary" disabled={busy}>
              {busy ? "Confirmando…" : "Gerar novos códigos"}
            </button>
          </form>
        )}
      </Modal>
    </>
  );
}
